/**
 * Generated by orval v8.6.2 🍺
 * Do not edit manually.
 * Marketplace API
 * OpenAPI spec version: 1.0.0
 */

/**
 * * `CL` - Collection from supplier
* `XP` - Export
* `BL` - BOL date
* `DA` - Destination port arrival
* `SD` - Site delivery
* `IA` - ICD arrival
 */
export type PaymentEventEnum = typeof PaymentEventEnum[keyof typeof PaymentEventEnum];


export const PaymentEventEnum = {
  CL: 'CL',
  XP: 'XP',
  BL: 'BL',
  DA: 'DA',
  SD: 'SD',
  IA: 'IA',
} as const;
